<template>
  <ims-page class="prelaunch bg-white">
    <!-- Page Header -->
    <template v-slot:header>
      <ims-toolbar color="white" class="text-primary">
        <template v-slot:left>
          <ims-menu-button />
        </template>
        <span class="title md text-uppercase">
          {{ $store.state.brand.name }}
          <br />
          {{ $store.state.brand.gameName }}
        </span>
      </ims-toolbar>
    </template>

    <main class="container p-3 h-100 d-flex flex-column">
      <div class="logo-mast my-4 p-2 text-center">
        <img :src="$store.state.brand.gameLogo" width="300" class="flex-grow-off" alt="header-logo" />
      </div>

      <ims-button
        v-if="!$store.state.user.loggedIn && !$store.state.user.loggingIn"
        aria-label="Register early for the Fantasy Challenge"
        type="solid"
        color="blue"
        size="md"
        class="btn-block my-3 flex-shrink-off pre-register-button"
        @click="login"
      >Sign Up / Login</ims-button>

      <ims-button
        v-if="$store.state.user.loggingIn"
        aria-label
        type="solid"
        color="blue"
        size="md"
        class="btn-block my-3 flex-shrink-off pre-register-button"
      >Loading...</ims-button>

      <ims-button
        v-if="$store.state.user.loggedIn && !$store.state.user.loggingIn"
        type="solid"
        aria-label="Edit your Profile"
        color="white"
        size="md"
        class="btn-block my-3 flex-shrink-off edit-profile-button"
        @click="$store.dispatch('interact/modals/profile/toggle')"
      >Edit Profile</ims-button>
        
      <div class="container-sm">
          <hr />
          <p v-if="$store.state.brand.id == 1" class="text-xs">
              NO PURCHASE NECESSARY. To enter, register between 2/27/2023 - 9/10/2023 on the INDYCAR Mobile App or the Website.  Must be 18+ to play; legal US resident to win prizes.  App avail. major app stores.  Standard data rates apply.  Access
              <a href="https://www.indycar.com/FantasyChallenge/INDYCAR/FullRules" title="Full Official Rules">Full Official Rules</a>
              for prize information and restrictions.  Sponsor: INDYCAR, LLC 4551 West 16th Street, Indianapolis, IN 46222.
          </p>
          <p v-if="$store.state.brand.id == 2" class="text-xs">
              NO PURCHASE NECESSARY. To enter, register between 2/27/2023 - 9/10/2023 on the FirestoneRacingChallenge.com website.  Access
              <a href="https://www.indycar.com/FantasyChallenge/Firestone/FullRules" title="Full Official Rules">Full Official Rules</a>
              for prize information and restrictions.
          </p>
      </div>

      <div class="ad-block filler"></div>
    </main>
  </ims-page>
</template>

<script>
import headerLogo from '../assets/logo-full.svg';
import tick from '../modules/tick/tick';

export default {
  data() {
    return {
      headerLogo: headerLogo,
      loggingIn: false
    };
  },
  methods: {
    async login() {
      return await this.$store.dispatch('user/login');
    }
  },
  watch: {
    '$User.profile': {
      handler(profileId) {
        if (profileId) {
          this.$router.push('/home');
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@import '../scss/utils/variables';

.prelaunch {
  height: 100vh;
}

.ad-block {
  // background-color: $gray-200;
  min-height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
}
</style>
